import { render, staticRenderFns } from "./PrescriptionProductsSearch.vue?vue&type=template&id=922e8346&scoped=true&"
import script from "./PrescriptionProductsSearch.vue?vue&type=script&lang=js&"
export * from "./PrescriptionProductsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922e8346",
  null
  
)

export default component.exports